module.exports = __webpack_public_path__ + "static/media/actresses.6904cfd6.jpg";